const isWithinRange = (value, [lowerLimit, upperLimit]) => {
  return lowerLimit <= value && value <= upperLimit;
};

const filters = {
  dateCommenced: ({ overview: { dateCommenced } }, range) => {
    return isWithinRange(dateCommenced, range);
  },
  purchaseCost: ({ overview: { purchaseCost } }, range) => {
    return isWithinRange(purchaseCost, range);
  },
  shareCost: ({ overview: { shareCost } }, range) => {
    return isWithinRange(shareCost, range);
  },
  salePrice: ({ exitStrategies }, range) => {
    let isMatch = true;

    for (const { salePrice } of exitStrategies) {
      if (salePrice.length === 1 && !isWithinRange(salePrice[0], range)) isMatch = false;
      else if (salePrice[0] < range[0] || salePrice[1] > range[1]) isMatch = false;
    }

    return isMatch;
  },
  sharesStatus: ({ overview: { sharesStatus } }, value) => {
    if (value === "All") return true;
    return sharesStatus === value;
  }
};

class ProjectCollection {
  constructor(projects) {
    this.projects = projects;
    const filterMatches = projects.map(({ id }) => id);

    this.matches = {
      filter: filterMatches,
      search: []
    };

    setTimeout(() => {
      this.addImageDataURLs();
    }, 3000);
  }

  getProject(id) {
    return this.projects.find((project) => project.id === id);
  }

  getMatches(matchType) {
    return this.projects.filter(({ id }) => this.matches[matchType].includes(id));
  }

  getRanges() {
    const setValue = (property, value) => {
      if (!ranges[property][0]) ranges[property][0] = value;
      else if (value < ranges[property][0]) ranges[property][0] = value;
      else if (value > ranges[property][1]) ranges[property][1] = value;
    };

    let ranges = {
      dateCommenced: ["", ""],
      purchaseCost: [0, 0],
      shareCost: [0, 0],
      salePrice: [0, 0]
    };

    for (const { overview, exitStrategies } of this.projects) {
      for (const property of ["dateCommenced", "purchaseCost", "shareCost"]) {
        setValue(property, overview[property]);
      }

      for (const { salePrice } of exitStrategies) {
        setValue("salePrice", salePrice[0]);
        if (salePrice.length === 2) setValue("salePrice", salePrice[1]);
      }
    }

    return ranges;
  }

  filter(values) {
    this.matches.filter = [];

    const matches = this.projects.filter(({ id, ...properties }) => {
      let isMatch = true;

      for (const property in values) {
        if (!filters[property](properties, values[property])) isMatch = false;
      }

      if (isMatch) this.matches.filter.push(id);
      return isMatch;
    });

    return matches;
  }

  search(text) {
    this.matches.search = [];
    const addScores = (scores) => Object.values(scores).reduce((sum, score) => sum + score, 0);
    const regex = new RegExp(text, "gi");
    let results = [];
    const searchProperties = ["name", "location", "description"];

    for (const project of this.projects) {
      const result = {
        id: project.id,
        scores: {
          name: 4,
          location: 2,
          description: 1
        }
      };

      let matchFound = false;

      for (const property of searchProperties) {
        if (!regex.test(project[property])) result.scores[property] = 0;
        else matchFound = true;
      }

      if (matchFound) {
        for (const property of searchProperties) {
          result[property] = project[property];
          result.image = project.images[0].small;
        }

        results.push(result);
        this.matches.search.push(project.id);
      }
    }

    return results
      .sort((project1, project2) => addScores(project2.scores) - addScores(project1.scores))
      .map(({ scores, ...rest }) => {
        rest.matchedProperties = [];
        // Try removing this, it seems redundant
        for (const property of searchProperties) {
          if (scores[property] > 0) rest.matchedProperties.push(property);
        }

        return rest;
      });
  }

  addImageDataURLs() {
    this.imageDataURLs = {};

    for (const {
      id,
      images: [mainImage]
    } of this.projects) {
      fetch(`${mainImage.small}`)
        .then((response) => response.blob())
        .then((blob) => {
          const reader = new FileReader();

          reader.onload = () => {
            mainImage.small = reader.result;
          };

          reader.readAsDataURL(blob);
        });
    }
  }
}

export default ProjectCollection;